// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.marginTop{
  margin-top: 200px !important;
}

.highlight {
  background-color: yellow !important; /* Change the background color to highlight */
  /* Add any other styles for highlighting */
}

.logout{
  text-decoration: none;
  color: black;
}

.container2{
  margin-left: 20px;
  margin-right: 20px;
}

.modal-content {
  height: 500px;
  overflow-x: scroll;
}

.container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
}

.container1 {
  background-color: #fff;
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.s1 {
  text-align: center;
}

.small1 {
  color: #555;
  font-size: 14px;
  margin-top: 10px;
}

.h1 {
  font-size: 28px;
  color: #333;
  margin: 20px 0;
}

.s2 {
  padding: 20px 0;
}

.formgroup {
  margin-bottom: 20px;
}

.label {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
  display: block;
}

.input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.fp {
  text-align: right;
}

.link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.button1 {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
}

.button1:hover {
  background-color: #0056b3;
}

.link2 {
  text-align: center;
  margin-top: 10px;
  color: #333;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

/* Pagination container */
.pagination {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
}

/* Individual pagination item */
.pagination li {
  margin: 0 4px;
  display: inline-block;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #fff;
}

/* Active pagination item */
.pagination li.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

/* Previous and Next buttons */
.pagination li.previous,
.pagination li.next {
  font-weight: bold;
}

/* Disabled pagination item (e.g., disabled Previous/Next) */
.pagination li.disabled {
  color: #ccc;
  cursor: not-allowed;
}

.table-container {
  max-height: 600px; /* Adjust the height as needed */
  overflow: auto;
  overflow-x: auto;
  position: relative;
}
.table-container thead th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
.fixed-header th:first-child{
  position:sticky;
  left:0px;
  background-color:rgb(255, 255, 255);
}
.sticky-body  td:first-child
{
  position:sticky;
  left:0px;
  background-color:rgb(255, 255, 255);
}
.check{
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}
.aman{
  width: 2000px !important;
  overflow-x: scroll;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #333;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.btn-purple {
  background-color: purple;
  color: white; /* You may need to adjust the text color for better contrast */
  /* Add any additional styling as needed */
}

.fixBottom{
  width: 100% !important;
  height: 60px;
  background-color: white;
  position: fixed;
  bottom: 0;
  padding-top: 0.7rem;
  padding-bottom: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC,EAAE,6CAA6C;EAClF,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;;EAEE,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,eAAe;EACf,QAAQ;EACR,mCAAmC;AACrC;AACA;;EAEE,eAAe;EACf,QAAQ;EACR,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,YAAY,EAAE,8DAA8D;EAC5E,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.marginTop{\n  margin-top: 200px !important;\n}\n\n.highlight {\n  background-color: yellow !important; /* Change the background color to highlight */\n  /* Add any other styles for highlighting */\n}\n\n.logout{\n  text-decoration: none;\n  color: black;\n}\n\n.container2{\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.modal-content {\n  height: 500px;\n  overflow-x: scroll;\n}\n\n.container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f4f4f4;\n}\n\n.container1 {\n  background-color: #fff;\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.s1 {\n  text-align: center;\n}\n\n.small1 {\n  color: #555;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.h1 {\n  font-size: 28px;\n  color: #333;\n  margin: 20px 0;\n}\n\n.s2 {\n  padding: 20px 0;\n}\n\n.formgroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.fp {\n  text-align: right;\n}\n\n.link {\n  color: #007bff;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.button1 {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.button1:hover {\n  background-color: #0056b3;\n}\n\n.link2 {\n  text-align: center;\n  margin-top: 10px;\n  color: #333;\n}\n\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n/* Pagination container */\n.pagination {\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  padding: 0;\n}\n\n/* Individual pagination item */\n.pagination li {\n  margin: 0 4px;\n  display: inline-block;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  border: 1px solid #ccc;\n  padding: 5px 10px;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n/* Active pagination item */\n.pagination li.active {\n  background-color: #007bff;\n  color: #fff;\n  border-color: #007bff;\n}\n\n/* Previous and Next buttons */\n.pagination li.previous,\n.pagination li.next {\n  font-weight: bold;\n}\n\n/* Disabled pagination item (e.g., disabled Previous/Next) */\n.pagination li.disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.table-container {\n  max-height: 600px; /* Adjust the height as needed */\n  overflow: auto;\n  overflow-x: auto;\n  position: relative;\n}\n.table-container thead th {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 1;\n}\n.fixed-header th:first-child{\n  position:sticky;\n  left:0px;\n  background-color:rgb(255, 255, 255);\n}\n.sticky-body  td:first-child\n{\n  position:sticky;\n  left:0px;\n  background-color:rgb(255, 255, 255);\n}\n.check{\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 2;\n}\n.aman{\n  width: 2000px !important;\n  overflow-x: scroll;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #333;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n.btn-purple {\n  background-color: purple;\n  color: white; /* You may need to adjust the text color for better contrast */\n  /* Add any additional styling as needed */\n}\n\n.fixBottom{\n  width: 100% !important;\n  height: 60px;\n  background-color: white;\n  position: fixed;\n  bottom: 0;\n  padding-top: 0.7rem;\n  padding-bottom: 1rem;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
